module.exports = __webpack_public_path__ + "img/icon_tab3.d4e7b30c.png";